import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { createUploadLink } from 'apollo-upload-client';
import { memoize } from 'lodash';
import { setBackendUrl } from './request';
import { API_URL } from '../utils/constants';

const canUseLocal = false;
const baseUrl = (canUseLocal && window.location.hostname === 'localhost')
  ? 'http://localhost:5000'
  : API_URL;

setBackendUrl(baseUrl);
export const getBaseUrl = () => baseUrl;
export const authenticationBaseUrl = `${baseUrl}/v4/session/login`;
const subdomain = window.location.hostname.toLowerCase().split('.')[0];
const productionSites = ['beta'];
export const env = productionSites.includes(subdomain) ? 'prod' : 'stage';

function handleError({ graphQLErrors, networkError }) {
  if (graphQLErrors)
    graphQLErrors.forEach(({ message, locations, path }) =>
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
      ),
    );
  if (networkError) console.log(`[Network error]: ${networkError}`);
}

const create = ({ headers, ...options }) => new ApolloClient({
  link: createUploadLink({
    uri: `${baseUrl}/v4`,
    headers: {
      'keep-alive': 'true',
      ...headers,
    },
    ...options,
  }),
  /*link: ApolloLink.from([
    onError(handleError),
    new HttpLink({
      uri: `${baseUrl}/v4`,
//      credentials: 'same-origin'
      ...options,
    })
  ]),*/
  cache: new InMemoryCache({
    addTypename: false,
  }),
});

export function createClient(headers) {
  return create({ headers });
}

export const removeConnections = obj => obj && typeof (obj) === 'object'
  ? Array.isArray(obj.edges)
    ? obj
      .edges
      .map(({ node }) => removeConnections(node))
    : Object.fromEntries(
      Object
        .entries(obj)
        .map(([key, value]) => {
          if (Array.isArray(value)) {
            return [key, value];
          }
          return [key, removeConnections(value)];
        })
    )
  : obj;

export const removeConnectionsMemoized = memoize(removeConnections);

const client = create({});

export default client;